module.exports = __webpack_public_path__ + "static/material-theme-60386e2bc5fad74400d28f0f3b907f11.png";